import { BaseService } from '@/core/base-service';

export default class TaskService extends BaseService<any> {
	public constructor() {
		super('services/servicezef/api/task');
	}
}
